import React from 'react';
import { CommItErrorScreen } from '../BaseErrorBoundary/CommItErrorScreen';

export const Unauthorized = () => (
    <CommItErrorScreen
        title="אין הרשאה למסך הזה"
        body="ייתכן שהסשן הסתיים או שההרשאות השתנו. התחברו מחדש כדי להמשיך."
    />
);
